<mat-form-field class="w-100" appearance="outline" [floatLabel]="valueSelected.size ? 'always': 'auto'">
  <div [style.margin]="valueSelected.size ? '-10px 10px -10px 0': ''">
    @for (option of optionSelected; track option) {
      <mat-chip (removed)="onRemove(option)" style="margin: 5px 5px 5px 0;">
        @if (option.image) {
          <img
            matChipAvatar class="option-image chip-image bg-primary" [src]="option.image" alt="{{option.label}}"
          />
        }

        {{ option.label }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>
    }

    <input
      matInput
      (blur)="onBlur()"
      (focus)="onFocus()"
      (keyup)="onKeyUp($event)"
      (change)="onChange($event)"
      [(ngModel)]="search"

      [placeholder]="placeholder || ''"
      [matAutocomplete]="auto"
      [style.width]="((search?.length || 0) * 8 + 5) + 'px'"

      type="text"
      class="{{errors?.length ? 'text-warning-500' : ''}}"
      style="max-width: 100%"
    />
  </div>

  <mat-label [classList]="errors?.length ? ['text-warning-300'] : []">
    {{ label }}
  </mat-label>
  <mat-icon matSuffix>arrow_drop_down</mat-icon>

  <mat-autocomplete #auto="matAutocomplete">
    @if (isLoading) {
      <mat-option disabled="true">Cargando datos ...</mat-option>
    }
    @for (option of optionList; track option) {
      @if (!valueSelected.has(option.value)) {
        <mat-option [value]="option.label" (click)="onSelect(option)">
          <div class="flex align-item-center option-item text-black-500">
            @if (option.image) {
              <div class="flex-shrink-0 m-r-10">
                <img class="option-image" [src]="option.image" alt="{{option.label}}" />
              </div>
            }

            <div class="flex-grow-1 p-2">
              {{ option.label }}
            </div>
          </div>
        </mat-option>
      }
    } @empty {
      <mat-option disabled="true">No hay datos</mat-option>
    }
  </mat-autocomplete>


  <mat-hint class="error-hint">
    @for (error of errors; track error) {
      <span class="bg-warning-500 text-white">
        {{ error.message }}
      </span>
    }
  </mat-hint>


</mat-form-field>

